import type {ActionResponse} from 'typings/portaro.be.types';
import {responseToData} from 'shared/utils/data-service-utils';
import type {IHttpResponse, IHttpService, ILogService} from 'angular';
import {actionRequestMethods} from '../constants/portaro.constants';
import type {AnyObject} from 'typings/portaro.fe.types';

export default class ActionRequestDataService {
    public static serviceName = 'actionRequestDataService';

    /*@ngInject*/
    constructor(private $http: IHttpService, private $log: ILogService) {
    }

    public async request(requestPath: string,
                         requestMethod: string = actionRequestMethods.GET,
                         requestBody?: any): Promise<ActionResponse> {
        try {
            const response: IHttpResponse<ActionResponse> = await this.doRequest(requestPath, requestMethod, requestBody);
            return responseToData(response);

        } catch (httpError) {
            throw responseToData(httpError);
        }
    }

    private async doRequest(requestUrl: string,
                            requestMethod: string,
                            requestBody?: AnyObject): Promise<IHttpResponse<ActionResponse>> {
        switch (requestMethod) {
            case actionRequestMethods.GET: return this.$http.get(requestUrl, {params: requestBody || {}});
            case actionRequestMethods.POST: return this.$http.post(requestUrl, requestBody || {});
            case actionRequestMethods.DELETE: return this.$http.delete(requestUrl);
            default: {
                this.$log.error(`Request method ${requestMethod} is not supported`);
                throw new Error(`Request method ${requestMethod} is not supported`);
            }
        }
    }

}
